class MultiquoteDebugInsuranceCompany {
    constructor(name, displayName) {
        this.name = name
        this.displayName = displayName
    }

    static fromJson({ name, displayName } = {}) {
        return new MultiquoteDebugInsuranceCompany(name, displayName)
    }
}

export default MultiquoteDebugInsuranceCompany
